import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Checkbox, TableCell, TableRow } from "@material-ui/core";
import { Controls, Header, Table } from "components/Table";
import { pathName } from "pages/routes";
import {
    copySchedulerRule,
    deleteSchedulerRule,
    editSchedulerRule,
    getSchedulerOverviewProcessingState,
    getSortableRules,
} from "store/features/emailScheduler/overview";
import { useDispatch, useSelector } from "react-redux";
import { useTableSort } from "hooks";
import Chip from "@material-ui/core/Chip";
import { ChipTableCell } from "components";

const rulesHeadCells = [
    { id: "isActive", numeric: false, disablePadding: false, isUnsortable: false, label: "Active" },
    { id: "name", numeric: false, disablePadding: false, label: "Name" },
    { id: "prodCodes", numeric: false, disablePadding: false, label: "Prod. Code" },
];

export const Rules: React.FC = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const rules = useSelector(getSortableRules);
    const { hasError, isDeleting } = useSelector(getSchedulerOverviewProcessingState);
    const { sortedFields, order, orderBy, toggleSort } = useTableSort(rules, "name");

    const handleEditSchedulerRule = (id: string) => {
        dispatch(editSchedulerRule(id));
    };

    const handleCopySchedulerRule = (id: string) => {
        dispatch(copySchedulerRule(id));
    };

    const handleDeleteSchedulerRule = (id: string) => {
        dispatch(deleteSchedulerRule.request(id));
    };

    return (
        <>
            <Header
                title={t("rules.label.headerTitle")}
                btnTitle={t("rules.label.createNewRule")}
                redirectTo={pathName.CREATE_SCHEDULER_CONFIG}
            />
            <Box p={2}>
                <Table headCells={rulesHeadCells} onSort={toggleSort} order={order} orderBy={orderBy}>
                    {sortedFields.map(({ id, name, active, prodCodes }, index) => (
                        <TableRow key={`${id || name}_${index}`}>
                            <TableCell padding="checkbox">
                                <Checkbox disabled={true} checked={active} name="checkedA" />
                            </TableCell>
                            <TableCell>{name}</TableCell>
                            <ChipTableCell padding="none">
                                {prodCodes.map((code, index) => (
                                    <Chip key={`${code}_${index}`} label={code} />
                                ))}
                            </ChipTableCell>
                            <TableCell align="right" padding="none">
                                <Controls
                                    id={name}
                                    redirectTo={pathName.CREATE_SCHEDULER_CONFIG}
                                    isProcessing={isDeleting}
                                    hasError={hasError}
                                    onEdit={handleEditSchedulerRule}
                                    onCopy={handleCopySchedulerRule}
                                    onDelete={handleDeleteSchedulerRule}
                                />
                            </TableCell>
                        </TableRow>
                    ))}
                </Table>
            </Box>
        </>
    );
};
